import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

var LVL = {
  ERROR:    { c: '#f87171', bg: 'rgba(239,68,68,0.07)' },
  CRITICAL: { c: '#f87171', bg: 'rgba(239,68,68,0.12)' },
  WARNING:  { c: '#fbbf24', bg: 'rgba(251,191,36,0.05)' },
  INFO:     { c: '#8b98a9', bg: 'transparent' },
  DEBUG:    { c: '#556677', bg: 'transparent' },
};

function todayIST() {
  var d = new Date();
  var ist = new Date(d.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  return ist.getFullYear() + '-' + String(ist.getMonth() + 1).padStart(2, '0') + '-' + String(ist.getDate()).padStart(2, '0');
}

var Logs = function () {
  var [rows, setRows] = useState([]);
  var [meta, setMeta] = useState({});
  var [dates, setDates] = useState([]);
  var [date, setDate] = useState(todayIST());
  var [level, setLevel] = useState('');
  var [q, setQ] = useState('');
  var [src, setSrc] = useState('');
  var [sort, setSort] = useState('desc');
  var [at, setAt] = useState('');
  var [offset, setOffset] = useState(0);
  var [loading, setLoading] = useState(false);
  var [bf, setBf] = useState({});
  var [pg, setPg] = useState({});
  var LIMIT = 500;

  var loadDates = useCallback(function () {
    fetch(API + '/logs/dates').then(function (r) { return r.json(); })
      .then(function (d) { setDates((d && d.dates) || []); }).catch(function () {});
  }, []);

  var pollBf = useCallback(function () {
    fetch(API + '/logs/backfill/status').then(function (r) { return r.json(); })
      .then(function (d) { setBf(d || {}); }).catch(function () {});
  }, []);

  useEffect(function () { loadDates(); pollBf(); }, [loadDates, pollBf]);

  // While a backfill runs, poll it and refresh the date list when it ends.
  useEffect(function () {
    if (!bf.running) return;
    var id = setInterval(function () {
      fetch(API + '/logs/backfill/status').then(function (r) { return r.json(); })
        .then(function (d) {
          setBf(d || {});
          if (d && !d.running) { loadDates(); }
        }).catch(function () {});
    }, 2000);
    return function () { clearInterval(id); };
  }, [bf.running, loadDates]);

  useEffect(function () {
    fetch(API + '/logs/purge/status').then(function (r) { return r.json(); })
      .then(function (d) { setPg(d || {}); }).catch(function () {});
  }, []);

  useEffect(function () {
    if (!pg.running) return;
    var id = setInterval(function () {
      fetch(API + '/logs/purge/status').then(function (r) { return r.json(); })
        .then(function (d) { setPg(d || {}); if (d && !d.running) { loadDates(); load(0); } })
        .catch(function () {});
    }, 1500);
    return function () { clearInterval(id); };
  }, [pg.running, loadDates, load]);

  function runPurge() {
    // Dry run first, then confirm with the real count. Deleting log history
    // should never happen on a single click.
    fetch(API + '/logs/purge', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ days: 60, dry_run: true }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.started) { alert(d.message); return; }
      var poll = setInterval(function () {
        fetch(API + '/logs/purge/status').then(function (r) { return r.json(); })
          .then(function (st) {
            setPg(st || {});
            if (st && !st.running) {
              clearInterval(poll);
              var n = st.removed || 0;
              if (!n) { alert('No WebSocket reconnect noise found in the last 60 days.'); return; }
              if (!window.confirm('Delete ' + n.toLocaleString('en-IN')
                    + ' WebSocket reconnect lines from past days?\n\n'
                    + 'Today is not touched. Each day-file is backed up as .jsonl.bak first.')) return;
              fetch(API + '/logs/purge', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ days: 60, dry_run: false }),
              }).then(function (r) { return r.json(); })
                .then(function (r2) { setPg((r2 && r2.status) || {}); })
                .catch(function () {});
            }
          }).catch(function () { clearInterval(poll); });
      }, 800);
    }).catch(function () {});
  }

  function runBackfill() {
    fetch(API + '/logs/backfill', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ days: 60 }),
    }).then(function (r) { return r.json(); })
      .then(function (d) { setBf((d && d.status) || {}); if (d && !d.started) { alert(d.message); } })
      .catch(function () {});
  }

  var load = useCallback(function (off, jumpTo) {
    setLoading(true);
    var u = API + '/logs?date=' + date + '&limit=' + LIMIT + '&offset=' + off
          + (jumpTo ? '&at=' + encodeURIComponent(jumpTo) : '')
          + (level ? '&level=' + level : '')
          + (src ? '&src=' + encodeURIComponent(src) : '')
          + (q ? '&q=' + encodeURIComponent(q) : '')
          + '&sort=' + sort;
    fetch(u).then(function (r) { return r.json(); }).then(function (d) {
      setMeta(d || {});
      setRows((d && d.rows) || []);
      // the server resolves a jump to a page-aligned offset — adopt it so
      // Prev/Next continue from where we landed
      if (d && typeof d.offset === 'number') { setOffset(d.offset); }
      setLoading(false);
    }).catch(function () { setLoading(false); });
  }, [date, level, q, src, sort]);

  useEffect(function () { setOffset(0); setAt(''); load(0); }, [load]);

  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10 };
  var input = { background: '#0d1524', border: '1px solid #26334a', borderRadius: 8, color: '#e5e7eb',
                fontSize: 12, padding: '7px 10px', fontFamily: 'inherit' };
  var counts = meta.counts || {};

  return (
    <div style={{ padding: '18px 22px', color: '#e5e7eb', fontFamily: 'inherit', maxWidth: 1500 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 22, fontWeight: 800 }}>📜 Logs</span>
        <span style={{ fontSize: 10, color: '#6b7a8d' }}>
          all backend records · IST · {sort === 'desc' ? 'newest first' : 'oldest first'}
        </span>
      </div>
      <div style={{ fontSize: 10, color: '#6b7a8d', marginBottom: 12 }}>
        {meta.total != null ? meta.total.toLocaleString('en-IN') + ' matching' : '—'}
        {counts.ERROR ? <span style={{ color: '#f87171' }}> · {counts.ERROR} errors</span> : null}
        {counts.WARNING ? <span style={{ color: '#fbbf24' }}> · {counts.WARNING} warnings</span> : null}
        {counts.INFO ? <span> · {counts.INFO} info</span> : null}
      </div>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12, alignItems: 'center' }}>
        <select value={date} onChange={function (e) { setDate(e.target.value); }} style={input}>
          {(dates.length ? dates : [{ date: date }]).map(function (d) {
            return <option key={d.date} value={d.date}>{d.date}</option>;
          })}
        </select>
        <input type="time" value={at} step="60"
          onChange={function (e) {
            var v = e.target.value;
            setAt(v);
            if (v) { load(0, v); }
          }}
          title="Jump to this time of day (IST)"
          style={{ ...input, width: 118, colorScheme: 'dark' }} />
        {at ? (
          <button onClick={function () { setAt(''); setOffset(0); load(0); }}
            title="Clear the time jump"
            style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8,
                     padding: '7px 10px', background: '#0d1524', color: '#8b98a9', border: '1px solid #26334a' }}>
            clear
          </button>
        ) : null}
        {[['', 'All'], ['INFO', 'Info+'], ['WARNING', 'Warn+'], ['ERROR', 'Errors']].map(function (o) {
          var on = level === o[0];
          return (
            <button key={o[0]} onClick={function () { setLevel(o[0]); }}
              style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8,
                       padding: '7px 14px', background: on ? 'rgba(56,189,248,0.14)' : '#0d1524',
                       color: on ? '#38bdf8' : '#8b98a9',
                       border: '1px solid ' + (on ? 'rgba(56,189,248,0.5)' : '#26334a') }}>{o[1]}</button>
          );
        })}
        <select value={src} onChange={function (e) { setSrc(e.target.value); }} style={input}>
          <option value="">All sources</option>
          {(meta.sources || []).map(function (s) { return <option key={s} value={s}>{s}</option>; })}
        </select>
        <input value={q} onChange={function (e) { setQ(e.target.value); }} placeholder="search…"
          style={{ ...input, minWidth: 220, flex: 1 }} />
        <button onClick={function () { setSort(sort === 'desc' ? 'asc' : 'desc'); }}
          title={sort === 'desc' ? 'Newest first — click for oldest first' : 'Oldest first — click for newest first'}
          style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8,
                   padding: '7px 14px', background: '#0d1524', color: '#38bdf8',
                   border: '1px solid rgba(56,189,248,0.45)', whiteSpace: 'nowrap' }}>
          {sort === 'desc' ? '↓ Newest first' : '↑ Oldest first'}
        </button>
        <button onClick={function () { setOffset(0); load(0); }}
          style={{ fontSize: 11, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 8,
                   padding: '7px 14px', background: '#0d1524', color: '#c4cfd8', border: '1px solid #26334a' }}>
          {loading ? '…' : 'Refresh'}
        </button>
        <button onClick={runBackfill} disabled={bf.running || bf.allowed === false}
          title={bf.allowed === false ? bf.reason : 'Rebuild older days from the system journal'}
          style={{ fontSize: 11, fontWeight: 800, fontFamily: 'inherit', borderRadius: 8, padding: '7px 14px',
                   cursor: (bf.running || bf.allowed === false) ? 'not-allowed' : 'pointer',
                   background: '#0d1524', color: bf.allowed === false ? '#556677' : '#a78bfa',
                   border: '1px solid ' + (bf.allowed === false ? '#1f2937' : 'rgba(167,139,250,0.45)'),
                   opacity: (bf.running || bf.allowed === false) ? 0.55 : 1 }}>
          {bf.running ? 'Backfilling ' + (bf.day || '…') : 'Backfill history'}
        </button>
        <button onClick={runPurge} disabled={pg.running || bf.running || pg.allowed === false}
          title={pg.allowed === false ? pg.reason
                 : 'One-off: delete WebSocket reconnect noise from PAST days. Today untouched, originals backed up.'}
          style={{ fontSize: 11, fontWeight: 800, fontFamily: 'inherit', borderRadius: 8, padding: '7px 14px',
                   cursor: (pg.running || bf.running || pg.allowed === false) ? 'not-allowed' : 'pointer',
                   background: '#0d1524', color: pg.allowed === false ? '#556677' : '#fbbf24',
                   border: '1px solid ' + (pg.allowed === false ? '#1f2937' : 'rgba(251,191,36,0.45)'),
                   opacity: (pg.running || bf.running || pg.allowed === false) ? 0.55 : 1 }}>
          {pg.running ? (pg.dry_run ? 'Scanning ' : 'Cleaning ') + (pg.day || '…') : 'Clean WS noise'}
        </button>
      </div>

      {(bf.running || bf.error || (bf.done && bf.files)) ? (
        <div style={{ ...card, padding: '9px 14px', marginBottom: 12, fontSize: 11,
                      borderColor: bf.error ? 'rgba(239,68,68,0.4)' : 'rgba(167,139,250,0.35)' }}>
          {bf.error
            ? <span style={{ color: '#f87171' }}>Backfill error: {bf.error}</span>
            : bf.running
              ? <span style={{ color: '#a78bfa' }}>
                  Reading the system journal — {bf.day || 'starting'} · {bf.files || 0} days, {(bf.records || 0).toLocaleString('en-IN')} records so far.
                  This is slow; it re-reads the whole journal.
                </span>
              : <span style={{ color: '#8b98a9' }}>
                  Backfill finished {bf.finished} — {bf.files} day(s), {(bf.records || 0).toLocaleString('en-IN')} records.
                </span>}
        </div>
      ) : null}

      {(pg.done && !pg.dry_run && pg.files) ? (
        <div style={{ ...card, padding: '9px 14px', marginBottom: 12, fontSize: 11,
                      borderColor: 'rgba(251,191,36,0.35)', color: '#8b98a9' }}>
          Removed {(pg.removed || 0).toLocaleString('en-IN')} WebSocket reconnect lines from {pg.files} day(s)
          {pg.bytes_saved ? ' — ' + Math.round(pg.bytes_saved / 1048576) + ' MB freed' : ''}.
          Originals kept as .jsonl.bak on the server.
        </div>
      ) : null}

      {bf.allowed === false ? (
        <div style={{ fontSize: 10, color: '#6b7a8d', marginBottom: 10 }}>
          Backfill is disabled during market hours — {bf.reason}
        </div>
      ) : null}

      <div style={{ ...card, padding: '4px 0', overflow: 'hidden' }}>
        {rows.length ? rows.map(function (e, i) {
          var s = LVL[e.lvl] || LVL.INFO;
          return (
            <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'baseline', padding: '4px 14px',
                                  background: s.bg, borderBottom: '1px solid #0d1524',
                                  fontSize: 11.5, fontFamily: 'ui-monospace, Menlo, monospace' }}>
              <span style={{ color: '#556677', flexShrink: 0, width: 62 }}>{e.ts}</span>
              <span style={{ color: s.c, fontWeight: 700, flexShrink: 0, width: 62 }}>{e.lvl}</span>
              <span style={{ color: '#e5e7eb', flex: 1, wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{e.msg}</span>
              <span style={{ color: '#6b7a8d', flexShrink: 0, textAlign: 'right', minWidth: 110 }}>{e.src}</span>
            </div>
          );
        }) : (
          <div style={{ fontSize: 11, color: '#6b7a8d', textAlign: 'center', padding: '28px 0' }}>
            {loading ? 'Loading…' : 'No records for these filters.'}
          </div>
        )}
      </div>

      {meta.total ? (function () {
        var page = Math.floor(offset / LIMIT) + 1;
        var pages = Math.max(1, Math.ceil(meta.total / LIMIT));
        var from = meta.total ? offset + 1 : 0;
        var to = Math.min(offset + LIMIT, meta.total);
        var btn = function (on) {
          return { fontSize: 12, fontWeight: 800, fontFamily: 'inherit', borderRadius: 8,
                   padding: '8px 20px', background: '#0d1524',
                   color: on ? '#c4cfd8' : '#3d5068',
                   border: '1px solid ' + (on ? '#26334a' : '#161f2e'),
                   cursor: on ? 'pointer' : 'not-allowed' };
        };
        var hasPrev = offset > 0;
        var hasNext = offset + LIMIT < meta.total;
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
                        gap: 14, marginTop: 12 }}>
            <button disabled={!hasPrev || loading}
              onClick={function () { var o = Math.max(0, offset - LIMIT); setOffset(o); load(o); }}
              style={btn(hasPrev && !loading)}>← Previous</button>
            <span style={{ fontSize: 11, color: '#6b7a8d', minWidth: 210, textAlign: 'center' }}>
              {loading ? 'Loading…'
                : from.toLocaleString('en-IN') + '–' + to.toLocaleString('en-IN')
                  + ' of ' + meta.total.toLocaleString('en-IN')
                  + '  ·  page ' + page + '/' + pages
                  + (meta.jumped_to ? '  ·  at ' + meta.jumped_to : '')}
            </span>
            <button disabled={!hasNext || loading}
              onClick={function () { var o = offset + LIMIT; setOffset(o); load(o); }}
              style={btn(hasNext && !loading)}>Next →</button>
          </div>
        );
      }()) : null}
    </div>
  );
};

export default Logs;
